import { useEffect, useState } from "react"
import { ReactMarkdown } from "react-markdown/lib/react-markdown"
import { AnimatePresence, LayoutGroup, delay, motion } from "framer-motion";
import Logo from "../../components/Logo";
import api from "../../api";
import rehypeRaw from "rehype-raw";

// import {ReactComponent as ChevronRight } from "../../assets/icons/chevron-right-solid.svg"
const ChevronRightSVG = require("../../assets/icons/chevron-right-solid.svg").default


const showResultVariants = {
  hidden: {
    opacity: 0,
    display: 'none'
  },
  visible: {
    opacity: 1,
    display: 'block',
    transition: {
      delay: 0.3

    }
  }
}

const markdownComponents = {
  img: ({ src, alt, title, ...props }) => (
    <img style={{ minWidth: '20%', maxWidth: '100%', display: 'block', margin: '0 auto' }} src={src} alt={alt} title={title} {...props} />
  ),
  p: ({children, ...props}) => (
    <p style={{fontSize: '20px'}} {...props}>{children}</p>
  )

}


const CreateBlog = () => {

  const [blogInput, setBlogInput] = useState('')
  const [expandOutput, setExpandOutput] = useState(false)
  const [imageLinks, setImageLinks] = useState([]);

  const [blogTitle, setBlogTitle] = useState('');
  const [blogThumbnail, setBlogThumbnail] = useState('');
  const [blogType, setBlogType] = useState('');
  const [blogRating, setBlogRating] = useState('');
  const [blogPassword, setBlogPassword] = useState('');

  const [blogFormPassword, setBlogFormPassword] = useState('')






  // COnvert to 
  const handleImageUpload = async (e) => {
    e.preventDefault();

    const form = e.target;

    // this is where images are stored in binary
    // console.log(await form['0'].files[0].text());
    // form['0] is the input tag
    const data = new FormData(form);
    data.set('password', blogPassword);


    const response = await api.post('/post/image', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    setImageLinks([...imageLinks, response.data.imageURL])
  }

  // Automatically resizes the text area to fit content
  // Was done to simulate the scrolling down effect of blog posts
  const handleKeyDown = (e) => {
    e.target.style.height = 'inherit';
    e.target.style.height = `${e.target.scrollHeight + 20}px`;


    // In case need limit
    // e.target.style.height = `${Math.min(e.target.scrollHeight, limit)}px`;
  }


  const handleBlogSubmit = async (e) => {
    e.preventDefault();
    console.log(blogFormPassword)
    const data = {
      'title': blogTitle,
      'content': blogInput,
      'type': blogType,
      'rating': blogRating,
      'password': blogFormPassword,
      'thumbnail': blogThumbnail
    }

    const response = await api.post('/post', data);

    console.log(response.data);


  }

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Leaving this page will reset the wizard";
    };
  }, [])




  return (
    <div className=' d-flex flex-column flex-grow-1 mb-2'>
      <div className="blogCreateTopBar">
        <div className="blogCreateTopBarContainer">
          <div className="d-flex align-items-center align-self-center">
            <Logo />
            <small className="ms-4">Draft Blog</small>
          </div>
          <div className="ms-auto align-self-center">

          </div>
        </div>
      </div>

      <div className="blogCreateImageBar">

        <div className="blogCreateImageContainer">
          <small>Image Upload</small>
          <div className="blogCreateImageInput">
            <form className="input-group" encType="multipart/form-data" onSubmit={handleImageUpload}>
              <input className="form-control" type="file" id="file" accept="image/*" name="imageFile" required />
              <input type="password" className="form-control" placeholder="Enter Password" required onChange={(e) => setBlogPassword(e.target.value)} />

              <button className="btn btn-secondary" type="submit">Submit</button>
            </form>
          </div>
          {
            imageLinks.map((link, index) =>
              <div>
                <small>Link to image {index + 1}: <a href={link} target="_blank" rel="noreferrer">{link}</a></small>

              </div>
            )
          }
        </div>


      </div>



      <form onSubmit={handleBlogSubmit}>


        <LayoutGroup>
          <div className="blogCreateThumbnailBar">
            <div className="blogCreateThumbnailContainer">
              <div className="mb-2 align-items-center d-flex justify-content-center">
                {blogThumbnail ? <img alt="none" className="blogEntryThumbnail" src={blogThumbnail} /> : <div className="blogEntryThumbnailPlaceholder"/>}
              </div>
              <div className="input-group">
                <input type="text" className="form-control" placeholder="Enter Thumbnail Link" onChange={(e) => setBlogThumbnail(e.target.value)} />
              </div>
            </div>

          </div>
          <div className="min-vh-100 d-flex flex-column">
            <div className="blogCreateTitleBar">
              <div className="blogCreateTitleContainer">
                <div className="input-group">
                  <input placeholder="Title" type='text' className="form-control" autoComplete="off" onChange={(e) => setBlogTitle(e.target.value)}></input>

                </div>
              </div>
            </div>

            <div className="flex-row d-flex justify-content-center flex-grow-1 pt-2">



              <motion.textarea spellCheck="false" layout className={` flex-fill w-50 mw-740p mx-2 px-2 py-2 blogInput ${expandOutput && 'border-end'}`} onKeyDown={handleKeyDown} onChange={e => setBlogInput(e.target.value)} placeholder="Tell your story..."></motion.textarea>
              <AnimatePresence>
                {expandOutput &&
                  <motion.div layout className={`w-50 mw-740p mx-2 px-2`} exit={{ opacity: 0 }}>
                    <ReactMarkdown skipHtml={false} className={`w-100 h-100 blogPostContent`} rehypePlugins={[rehypeRaw]} components={markdownComponents} children={blogInput ? blogInput : "Tell your story..."} />
                  </motion.div>
                }

              </AnimatePresence>
              <motion.div layout className="expandButton" onClick={() => setExpandOutput(!expandOutput)}>
                {!expandOutput &&
                  <motion.text variants={showResultVariants} initial="hidden" animate="visible" exit="hidden" className={"blogShowResultText"}>Show Result</motion.text>
                }
                <motion.img layout src={ChevronRightSVG} alt="btn" className="blogChevron" />
              </motion.div>




            </div>
            <div className="blogCreateSubmitBar">
              <div className="blogCreateSubmitContainer">
                <div className="input-group">
                  <select className="form-select" required onChange={(e) => setBlogType(e.target.value)}>
                    <option value="" disabled selected hidden>Choose blog type...</option>
                    <option value='game'>Game</option>
                    <option value='music'>Music</option>
                    <option value='book'>Book</option>
                    <option value='show'>Show</option>
                  </select>
                  <select className="form-select" required onChange={(e) => setBlogRating(e.target.value)}>
                    <option value="" disabled selected hidden>Choose blog rating...</option>
                    <option value='S'>S</option>
                    <option value='A'>A</option>
                    <option value='B'>B</option>
                    <option value='C'>C</option>
                    <option value='F'>F</option>

                  </select>
                  <input type="password" required className="form-control" placeholder="Enter Password" onChange={(e) => setBlogFormPassword(e.target.value)} />
                  <input type="submit" className="btn btn-secondary" value={"Submit"} />


                </div>


              </div>
            </div>
          </div>
        </LayoutGroup>

      </form>


      {/* <div className="w-50 mw-740p rounded mx-2 border-black" /> */}


    </div>
  )
}


export default CreateBlog